import { MessageCircleMore } from "lucide-react";
import { trackContactClick } from "../lib/analytics";
import { GENERAL_WHATSAPP_MESSAGE, getWhatsAppUrl } from "../lib/contact";

export default function WhatsAppContactButton({ propertyTitle }) {
  const message = propertyTitle
    ? `Bonjour, je souhaite obtenir plus d'informations sur le bien « ${propertyTitle} ». Pouvez-vous me rappeler ?`
    : GENERAL_WHATSAPP_MESSAGE;
  const whatsappUrl = getWhatsAppUrl(message);
  const isPropertyButton = Boolean(propertyTitle);
  return (
    <a
      className={isPropertyButton ? "property-whatsapp-button" : "whatsapp-contact-button"}
      href={whatsappUrl}
      target="_blank"
      rel="noopener noreferrer"
      onClick={() => trackContactClick("whatsapp", isPropertyButton ? "property" : "floating")}
      aria-label={isPropertyButton ? `Poser une question sur ${propertyTitle} via WhatsApp` : "Contacter Pimp My Place sur WhatsApp"}
      data-testid={isPropertyButton ? "property-whatsapp-button" : "whatsapp-contact-button"}
    >
      <MessageCircleMore size={21} aria-hidden="true" />
      <span>{isPropertyButton ? "Question sur ce bien" : "WhatsApp"}</span>
    </a>
  );
}